import React, { useContext, useEffect, useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import { useHistory } from "react-router";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import { PortalContext } from "../../context/Provider";
import Modal from "../../components/Genericos/Modal/Modal";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import BuscadorEstudio from "../../components/Turnos/BuscadorEstudio/BuscadorEstudio";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { estudioGrupo } from "../../context/Actions/estudioGrupo/estudioGrupo";
import "./Estudios.css";
import {
  LimpiarSelectE,
  LimpiarSelectGlobal,
  SelectUserE,
  SelectUserGlobal,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { showModal } from "../../context/Actions/modal/modal";
import Loading from "../../components/Genericos/Loading/Loading";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { logoutEstudiosTurnos } from "../../context/Actions/turnos/estudioTurnos";
import { GlobalContext } from "../../../global/context/Provider";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";
import { FaChevronLeft } from "react-icons/fa";
import styled from "styled-components";

const Estudios = () => {
  const history = useHistory();
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    estudioTurnosState,
    modalState,
    laboGrupoDispatch,
    laboGrupoState,
    modalDispatch,
    selectDropDownDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    estudioTurnosDispatch,
    pacienteState,
  } = useContext(PortalContext);
  // Nuevo contexto
  const { authState, toasterState, configState } = useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  //repetir en las paginas para tener los datos de los grupos
  useEffect(() => {
    if (configState.config.data !== null) {
      if (estudioGrupoState.estudioGrupo.data === null) {
        estudioGrupo()(estudioGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.data === null &&
        configState.config.data.opcLaboratorio
      ) {
        laboGrupo()(laboGrupoDispatch);
      }
      if (
        laboGrupoState.laboGrupo.centros === null &&
        configState.config.data.opcLaboratorio
      ) {
        wsGetLaboCentros()(laboGrupoDispatch);
      }
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
        "ESTUDIOS"
      ) {
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
      }
    }
    //eslint-disable-next-line
  }, [configState.config.data]);

  // ONCHANGE DE LOS DROPDOWNS
  const onChangeMultitabMobile = (e) => {
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth?.data?.paciente?.codigo &&
        e.manejoTurnos
      ) {
        SelectUserE({ id: e.id, paciente: e.paciente })(selectDropDownDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
      } else if (e.id !== authState.auth?.data?.paciente?.codigo) {
        // Toaster que te dice que no estás autorizado
        showModal(
          "Perfil/ModalAlertGrupoFamiliar/ModalAlertGrupoFamiliar",
          {},
          "centro",
        )(modalDispatch);

        LimpiarSelectE()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectE()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      }
    } else {
      LimpiarSelectE()(selectDropDownDispatch);
      // se comenta debido a que apenas hago click,
      // y busque algo, me hace la verifición
      // LimpiarSelectGlobal()(selectDropDownDispatch);
    }
  };

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />

      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          estudioTurnosState.estudioTurnos.loading ||
          pacienteState.paciente.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading && "Cargando estudios...") ||
          (pacienteState.paciente.loading && "Cargando datos...") ||
          (estudioTurnosState.estudioTurnos.loading && "Cargando...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando estudios...")
        }
      />
      {estudioGrupoState.estudioGrupo.data && (
        <motion.div
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          className="ptur-bodyContainer-Estudios"
        >
          {/* <Sidebar /> */}
          <div className="ptur-estudios-container">
            <VolverBtn
              type="button"
              onClick={() => history.push("/autocheckin")}
              aria-label="Volver al inicio"
            >
              <FaChevronLeft />
              <span className="c-white rb16m">Volver</span>
            </VolverBtn>
            <TituloSaludo />
            <div className="ptur-estudios-buscador">
              {/* <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} /> */}
              <BuscadorEstudio
                onChangeMultitabMobile={onChangeMultitabMobile}
              />
            </div>
          </div>
        </motion.div>
      )}
      {/* <FooterBar /> */}
    </React.Fragment>
  );
};
export default Estudios;

const VolverBtn = styled.button`
  display: none;
  @media (min-width: 768px) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 40px;
    padding: 0 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    border: 1px solid var(--color-latex30);
    background: var(--color-latex10);
    color: var(--color-white);
    cursor: pointer;
    transition:
      background 0.2s ease,
      color 0.2s ease,
      border-color 0.2s ease;
    &:hover {
      background: var(--color-latex30);
    }
    svg {
      font-size: 16px;
      color: var(--color-white);
    }
  }
`;
